import { mask, unMask } from "../../../../../utils/MascaraDeCampos";

export function formatDateLocal(dateStr: string, timeZone: string = 'America/Sao_Paulo') {
  const formatter = new Intl.DateTimeFormat('pt-BR', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  // Cria um Date considerando a string "YYYY-MM-DD" como data local
  const [year, month, day] = dateStr.split('-').map(Number);
  const localDate = new Date(year, month - 1, day); // sem fuso aplicado

  return formatter.format(localDate);
}

export function formatarTextoComAcentosCompleto(texto: string): string {
  const textoMinusculo = texto.toLowerCase();

  if (textoMinusculo === "certidoes_finep") {
    return "Certidões Finep/BNDES";
  }

  if (textoMinusculo === 'certidao') {
    return 'Certidão';
  } else if (textoMinusculo === 'certidoes') {
    return 'Certidões';
  } else if (textoMinusculo.startsWith('certidao_')) {
    const restante = textoMinusculo.substring('certidao_'.length).replace(/_/g, ' ');
    const restanteFormatado = restante
      .split(' ')
      .map(palavra => palavra.charAt(0).toUpperCase() + palavra.slice(1))
      .join(' ');
    return `Certidão ${restanteFormatado}`;
  } else if (textoMinusculo.startsWith('certidoes_')) {
    const restante = textoMinusculo.substring('certidoes_'.length).replace(/_/g, ' ');
    const restanteFormatado = restante
      .split(' ')
      .map(palavra => palavra.charAt(0).toUpperCase() + palavra.slice(1))
      .join(' ');
    return `Certidões ${restanteFormatado}`;
  } else if (textoMinusculo.endsWith('_certidao')) {
    const prefixo = textoMinusculo.substring(0, textoMinusculo.length - '_certidao'.length).replace(/_/g, ' ');
    const prefixoFormatado = prefixo
      .split(' ')
      .map(palavra => palavra.charAt(0).toUpperCase() + palavra.slice(1))
      .join(' ');
    return `${prefixoFormatado} Certidão`;
  } else if (textoMinusculo.endsWith('_certidoes')) {
    const prefixo = textoMinusculo.substring(0, textoMinusculo.length - '_certidoes'.length).replace(/_/g, ' ');
    const prefixoFormatado = prefixo
      .split(' ')
      .map(palavra => palavra.charAt(0).toUpperCase() + palavra.slice(1))
      .join(' ');
    return `${prefixoFormatado} Certidões`;
  } else {
    // Formatação genérica para todos os outros casos
    return textoMinusculo
      .replace(/_/g, ' ')
      .split(' ')
      .map(palavra => palavra.charAt(0).toUpperCase() + palavra.slice(1))
      .join(' ');
  }
}

export function maskCNPJ(value: any) {
  if (!value) return '';

  const originalValue = unMask(value);
  const maskedValue = mask(originalValue, [
    "99.999.999/9999-99"
  ]);

  return maskedValue

}
